import { Routes } from '@angular/router';
import {MainComponent} from './components/pages/main/main.component';
import {ChronologyComponent} from "./components/pages/chronology/chronology.component";
import {ArticleComponent} from "./components/pages/article/article.component";
import {FactComponent} from "./components/pages/fact/fact.component";
import {MapPageComponent} from "./components/pages/map-page/map-page.component";
import {HeroesComponent} from "./components/pages/heroes/heroes.component";
import {PanoramaComponent} from "./components/pages/panorama/panorama.component";
import {AuthGuardService} from "./services/auth-guard.service";
import {LoginComponent} from "./components/pages/login/login.component";
import {AdminComponent} from "./components/pages/admin/admin.component";

export const routes: Routes = [
  { path: '', component: MainComponent, pathMatch: 'full'},
  { path: 'chronology', component: ChronologyComponent},
  { path: 'article', component: ArticleComponent},
  { path: 'fact', component: FactComponent},
  { path: 'map', component: MapPageComponent},
  { path: 'heroes', component: HeroesComponent},
  { path: 'panorama', component: PanoramaComponent},
  { path: 'login', component: LoginComponent},
  { path: 'admin', canActivate: [AuthGuardService], component: AdminComponent},
  // { path: 'admin', component: AdminComponent},
];
